<div class="wrapper">
    <div class="cargando-jardin">
        <mat-spinner *ngIf="cargando"></mat-spinner>
    </div>
    <div *ngIf="!cargando" class="contenidoBase">

        <input type="checkbox" id="nav-toggle">
        <div class="sidebar">
            <div class="sidebar-brand profile">
                <div class="junji-profile">
                    <img src="../../../assets/icons/JUNJI__JUNJI-logo.svg">
                </div>
                <ng-template #popContent>
                    <button (click)="cambiarPass()" type="button" class="btn btn-light btn-popover"><i class="fas fa-key"></i> CAMBIAR CLAVE</button>
                    <button (click)="cambiarFoto()" type="button" class="btn btn-light btn-popover"><i class="fas fa-portrait"></i> CAMBIAR FOTO</button>
                    <button (click)="cerrarSesion()" type="button" class="btn btn-light btn-popover"><i class="fas fa-power-off"></i> SALIR</button>
                </ng-template>
                <ng-template #popTitle>Administrador/a</ng-template>
                <button class="image-cropper" placement="bottom" [ngbPopover]="popContent" [popoverTitle]="popTitle">
                        <img [src]="urlProfile" alt="avatar" id="improfile" class="profile-pic" >  
                </button>
                <p class="welcomeText">Bienvenida,</p>
                <p class="userName">Administrador/a</p>
            </div>
            <!--Secciones-del-tablero-->
            <div class="sidebar-menu">
                <ul>
                    <li>
                        <a (click)="menuVisible('inicio')" [className]="menuMostrar==='inicio'? 'active' : ''">
                            <img src="../../../assets/icons/JUNJI_inicio_off.svg" *ngIf="menuMostrar!='inicio'">
                            <img src="../../../assets/icons/JUNJI_inicio_on.svg" *ngIf="menuMostrar==='inicio'">
                            <span class="menu-text">ADMINISTRACIÓN USUARIOS</span>
                        </a>
                    </li>

                    <li>
                        <a (click)="menuVisible('mensajes')" [className]="menuMostrar==='mensajes'? 'active' : ''">
                            <img src="../../../assets/icons/JUNJI_inicio_off.svg" *ngIf="menuMostrar!='mensajes'">
                            <img src="../../../assets/icons/JUNJI_inicio_on.svg" *ngIf="menuMostrar==='mensajes'">
                            <span class="menu-text">MENSAJES</span>
                        </a>
                    </li>
                    
                    <li>
                        <p class="p-menu-etapas">REPORTES y DATOS</p>
                    </li>
                    
                    <li>
                        <a (click)="menuVisible('pei-inicio-view')" [className]="menuMostrar==='pei-inicio-view'? 'active' : ''">
                            <img src="../../../assets/icons/JUNJI_autoevaluacion_off.svg" *ngIf="menuMostrar!='pei-inicio-view'">
                            <img src="../../../assets/icons/JUNJI_autoevaluacion_on.svg" *ngIf="menuMostrar==='pei-inicio-view'">
                            <span class="menu-text">PROYECTO EDUCATIVO</span>
                        </a>
                    </li>
                   
                    <li>
                        <a (click)="menuVisible('new-planmejora')" [className]="menuMostrar==='new-planmejora'? 'active' : ''">
                            <img src="../../../assets/icons/JUNJI_plan-mejora_off.svg" *ngIf="menuMostrar!='new-planmejora'">
                            <img src="../../../assets/icons/JUNJI_plan-mejora_on.svg" *ngIf="menuMostrar==='new-planmejora'">
                            <span class="menu-text">PLAN DE MEJORAMIENTO EDUCATIVO</span>
                        </a>
                    </li>


                    <li>
                        <a (click)="menuVisible('pgc-view')" [className]="menuMostrar==='pgc-view'? 'active' : ''">
                            <img src="../../../assets/icons/plan_gestion_Off.svg" *ngIf="menuMostrar!='pgc-view'">
                            <img src="../../../assets/icons/plan_gestion_On.svg" *ngIf="menuMostrar==='pgc-view'">
                            <span class="menu-text">PLAN DE GESTIÓN CONVIVENCIA</span>
                        </a>
                    </li>

                    
                    <!--li>
                        <a (click)="menuVisible('instrumento-autoevaluacion')" [className]="menuMostrar==='instrumento-autoevaluacion'? 'active' : ''">
                            <img src="../../../assets/icons/autoevaluacion__Off.svg" *ngIf="menuMostrar!='instrumento-autoevaluacion'">
                            <img src="../../../assets/icons/autoevaluacion__On.svg" *ngIf="menuMostrar==='instrumento-autoevaluacion'">
                            <span class="menu-text">INSTRUMENTO DE AUTOEVALUACIÓN</span>
                        </a>
                    </li-->

                    <li>
                        <a (click)="menuVisible('reglamento-interno-view')" [className]="menuMostrar==='reglamento-interno-view'? 'active' : ''">
                            <img src="../../../assets/icons/reglamento_Off.svg" *ngIf="menuMostrar!='reglamento-interno-view'">
                            <img src="../../../assets/icons/reglamento_On.svg" *ngIf="menuMostrar==='reglamento-interno-view'">
                            <span class="menu-text">REGLAMENTO INTERNO</span>
                        </a>
                    </li>                
                    <li>
                        <a (click)="menuVisible('mantenedor-pei-view')" [className]="menuMostrar==='mantenedor-pei-view'? 'active' : ''">
                            <img src="../../../assets/icons/reglamento_Off.svg" *ngIf="menuMostrar!='mantenedor-pei-view'">
                            <img src="../../../assets/icons/reglamento_On.svg" *ngIf="menuMostrar==='mantenedor-pei-view'">
                            <span class="menu-text">MANTENEDOR PEI</span>
                        </a>
                    </li>
                    <li>
                        <a (click)="menuVisible('mantenedor-ri-view')" [className]="menuMostrar==='mantenedor-ri-view'? 'active' : ''">
                            <img src="../../../assets/icons/reglamento_Off.svg" *ngIf="menuMostrar!='mantenedor-ri-view'">
                            <img src="../../../assets/icons/reglamento_On.svg" *ngIf="menuMostrar==='mantenedor-ri-view'">
                            <span class="menu-text">MANTENEDOR RI</span>
                        </a>
                    </li>
                    <li>
                        <a (click)="menuVisible('biblioteca-view')" [className]="menuMostrar==='biblioteca-view'? 'active' : ''">
                            <img src="../../../assets/icons/biblioteca_Off.svg" *ngIf="menuMostrar!='biblioteca-view'">
                            <img src="../../../assets/icons/biblioteca_On.svg" *ngIf="menuMostrar==='biblioteca-view'">
                            <span class="menu-text">BIBLIOTECA</span>
                        </a>
                    </li>

                    
                </ul>
            </div>

            <div class="sidebar-brand">
                <button (click)="cerrarSesion()" type="button" class="btn btn-light btn-logout"><i class="fas fa-power-off"></i> Salir</button>
            </div>
        </div>


        <div class="main-content">
            <header>
                <div>
                    <p class="title1">
                        ESCRITORIO DIGITAL
                    </p>
                    <p class="title2">
                        del Jardín Infantil
                    </p>
                </div>
                <div class="user-wrapper">
                    <div>

                        <p class="title-jardin">ADMINISTRACIÓN GENERAL:</p>
                        <div class="jardin-name">
                            <p> Administrador/a</p>
                        </div>


                    </div>
                </div>
            </header>

            <main>
                <app-administracion *ngIf="menuMostrar==='inicio'"></app-administracion>
                <app-mensajeria *ngIf="menuMostrar==='mensajes'"></app-mensajeria>
                <app-consolidado *ngIf="menuMostrar==='consolidado'"></app-consolidado>
                <app-capacitacion *ngIf="menuMostrar==='capacitacion'"></app-capacitacion>
                <app-auto-evaluacion *ngIf="menuMostrar==='autoevaluacion-inicio-view'"></app-auto-evaluacion> 
                <app-admin-proyecto-educativo *ngIf="menuMostrar==='pei-inicio-view'"></app-admin-proyecto-educativo>
                <app-plan-gestion-convivencia-admin *ngIf="menuMostrar==='pgc-view'"></app-plan-gestion-convivencia-admin>
                <app-reglamento-interno-admin *ngIf="menuMostrar==='reglamento-interno-view'"></app-reglamento-interno-admin>
                <app-bibioteca-admin *ngIf="menuMostrar==='biblioteca-view'"></app-bibioteca-admin>
                <app-validacion *ngIf="menuMostrar==='validacion'"></app-validacion>
                <app-plan-de-mejoramiento *ngIf="menuMostrar==='planmejora'"></app-plan-de-mejoramiento> 
                <app-new-pme-admin *ngIf="menuMostrar==='new-planmejora'"></app-new-pme-admin> 
                <app-instrumento-autoevaluacion-admin *ngIf="menuMostrar==='instrumento-autoevaluacion'"></app-instrumento-autoevaluacion-admin>
                <app-mantenedor-pei *ngIf="menuMostrar==='mantenedor-pei-view'"></app-mantenedor-pei>
                <app-mantenedor-ri *ngIf="menuMostrar==='mantenedor-ri-view'"></app-mantenedor-ri>
            </main>

        </div>



        <div>
</div>


